const TEAMS = [
  { id: "moonshot",  name: "Moonshot Mafia", abbr: "MON", players: ["Nate","Lucas"],          color: "#6366f1" },
  { id: "banana",    name: "Banana Lords",   abbr: "BAN", players: ["Jackson","Urkel"],        color: "#eab308" },
  { id: "gnomes",    name: "Garlic Gnomes",  abbr: "GNO", players: ["Aiden","Nullet","Val"],   color: "#22c55e" },
  { id: "bees",      name: "The Bees",       abbr: "BEE", players: ["Will","Grimm"],           color: "#f97316" },
  { id: "nameless",  name: "The Nameless",   abbr: "NAM", players: ["Peter","Ryan"],           color: "#7d8590" },
  { id: "rizzlers",  name: "The Rizzlers",   abbr: "RIZ", players: ["Joe","Lorenzo"],          color: "#ef4444" },
  { id: "snowmen",   name: "The Snowmen",    abbr: "SNO", players: ["Joey","Sessa"],           color: "#38bdf8" },
];

export default TEAMS;